import React from 'react';
import { SectionHeading } from './SectionHeading';
import { mapFeatures } from '../data/landing';
export function MapAnatomySection() {
  return <section aria-labelledby="anatomia" className="bg-white" data-id="element-128" data-mp="3uy8ajeukpop1">
      
    </section>;
}